import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    .home-banner {
      .right-content {
        position: absolute;
        right: 10%;
        text-align: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        h2 {
          font-size: 2.5rem;
          font-weight: 700;
        }
        h3 {
          max-width: 60%;
          font-family: ${theme.font.comfortaa};
          font-weight: 300;
          font-size: ${theme.font.sizes.xxsmall};
          color: ${theme.colors.white};
        }
      }
      border-radius: 0 0 ${theme.border.radius} ${theme.border.radius};
      box-shadow: none;
      width: 100%;
      max-width: 1098px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
      max-height: 150px;
      position: relative;

      .home-banner-svg {
        position: absolute;
        bottom: 0;
        left: 15px;
      }

      h2 {
        font-family: ${theme.font.comfortaa};
        font-weight: ${theme.font.normal};
        font-size: ${theme.font.sizes.xlarge};
        color: ${theme.colors.white};
        margin-top: 0px;
        margin-bottom: 0px;
      }

      .home-banner-card {
        width: 100%;
        max-width: 581px;
        height: 100vh;
        max-height: 148px;
        padding: 20px 38px;
        z-index: 1;

        h3 {
          font-family: ${theme.font.comfortaa};
          font-weight: ${theme.font.xbold};
          font-size: ${theme.font.sizes.xxsmall};
          color: ${theme.colors.darkGray};
          margin-bottom: 20px;
        }

        .home-banner-card-input {
          display: flex;
          align-items: baseline;
          justify-content: space-between;

          label {
            margin-top: 0;
          }

          .home-banner-input {
            font-style: italic;
            margin: auto;
          }

          button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            border-radius: 50%;
            margin: 0 10px 0 20px;
            background: ${theme.colors.lightGray};
            transition: ${theme.transition.default};
            cursor: not-allowed;

            &.activeButton {
              cursor: pointer;
              background: ${theme.colors.primary};

              &:hover {
                filter: brightness(0.8);
              }
            }
          }
        }
      }
    }
  `}

  ${media.lessThan('huge')`
    .home-banner{
      max-height: 150px;
    }
  `}

  ${media.lessThan('medium')`
    ${({ theme }) => css`
      width: calc(100% - 81px);
      margin-left: auto;

      .home-banner {
        h2 {
          font-size: ${theme.font.sizes.large};
          z-index: 1;
        }

        .home-banner-card {
          max-height: 161px;

          h3 {
            text-align: center;
          }
        }
      }
    `}
  `}

  ${media.lessThan('small')`
    ${({ theme }) => css`
      .home-banner {
        .home-banner-svg {
          display: none;
        }

        .home-banner-card {
          padding: 14px 6px;

          h3 {
            font-size: ${theme.font.sizes.xxxsmall};
            text-align: center;
            margin-bottom: 12px;
          }
        }
      }
    `}
  `}
`

export const MenuContainer = styled.div`
  ${({ theme }) => css`
    max-width: 433px;
    background: ${theme.colors.white};
    max-height: 200px;
    overflow-y: scroll;
    border-radius: ${theme.border.radius};

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.primary};
      border-radius: 10px;
    }
  `}
`

export const CpfsMenu = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    cursor: pointer;
    padding: 20px 10px;
    border-radius: ${theme.border.radius};

    &:hover {
      background: ${theme.colors.primary};
      color: ${theme.colors.white};
    }
  `}
`
